import { ReactNode } from 'react';
import { makeStyles } from '@material-ui/core';
import { BreadcrumbItem } from '../../types';
import { PageHeader } from './PageHeader';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  content: {
    flex: 1,
    overflow: 'auto',
  },
});

interface CustomPageLayoutProps {
  title: string;
  breadcrumbs: BreadcrumbItem[];
  description?: string;
  showDate?: boolean;
  extra?: ReactNode;
  children: ReactNode;
}

export const CustomPageLayout = ({
  title,
  breadcrumbs,
  description,
  showDate = true,
  extra,
  children,
}: CustomPageLayoutProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <PageHeader
        title={title}
        breadcrumbs={breadcrumbs}
        description={description}
        showDate={showDate}
        extra={extra}
      />
      <div className={classes.content}>
        {children}
      </div>
    </div>
  );
};
